var html_el = jQuery('html');
var body_el = jQuery('body');

if (is_localhost) html_el.addClass('localhost');

// html_el.addClass('no-scroll');
var isDesktop = html_el.is('.desktop');
var isMobile = html_el.is('.mobile');
var isPhone = html_el.is('.phone');
// var isWechat = html_el.is('.wechat');
var isRetina = html_el.is('.retina');

// if ( Modernizr.testAllProps('clipPath') ) html_el.addClass('cssclippath');
// else html_el.addClass('no-cssclippath');

if ( Modernizr.testAllProps('mix-blend-mode') ) html_el.addClass('mixblend');
else html_el.addClass('no-mixblend');
if ( Modernizr.testAllProps('position', 'sticky') || Modernizr.testAllProps('position', '-webkit-sticky') ) html_el.addClass('csssticky');
else html_el.addClass('no-csssticky');
// html_el.addClass('no-csssticky');

var tt_root_scroll_wrap = $(document);
// var pd_thumbs_list_view = localStorage.getItem('tt_pd_list_view') == 'yes' ? true : false;
var tt_save_history = undefined;

var preloader = {
  pageloader: $('#pageloader'),
  init_page_timer: 0,

  init: function (cont_el) {
    var s = this;
    var cont = cont_el ? cont_el : body_el;
    var img_els = '';
    var totalImg = 0;
    var img_i = 1;

    img_els = cont.find('.preload_img');
    totalImg = img_els.length;

    if (totalImg > 0) startLoad();
    else loadOver();

    function startLoad() {
      img_els.each(function () {
        var th = $(this);
        var img_url;
        if (th.is('img')) img_url = th.attr('src');
        else img_url = th.data('img') || th.children('img.hide').attr('src');
        var image = new Image();
        image.src = img_url;
        image.complete ? imgLoaded() : image.onload = imgLoaded;
      });
    }

    function imgLoaded() {
      img_i == totalImg ? loadOver() : img_i++;
    }

    function loadOver() {
      $('.preload_img:not(img), .coverbg[data-img]').each(function () {
        var img_url = $(this).data('img') || $(this).children('img.hide').attr('src');
        // console.log(img_url);
        $(this).css('background-image', 'url(' + img_url + ')');
        $(this).children('img.hide').remove();
      });

      // if (cont.find('.nav-tabs').length) ttTab.init();
      // if (cont.find('.thumbs.grid').length && ics) gridThumbs.init();
      // if (cont.find('.sh-thumbs').length && ics) flexThumbs.init();
      scrollFixNav.init();

      setTimeout(function () {
        s.initPage();
      }, 200);
    }

  },

  initPage: function () {
    var s = this;
    var cont = body_el;
    var pageloader = s.pageloader;
    var trans_time = 400;

    // if (cont.find('.bgvideo-wrap').length) bgvideo.init();
    // if (cont.find('.dropdown-nav').length) dropdownNav.init();
    if (cont.find('.ttswiper').length) ttSwiper.init();
    if (ttSkrollr) ttSkrollr.init();

    body_el.removeClass('loading').addClass('init');
    if (pageloader.length) trans_time = parseFloat(pageloader.css('transition-duration')) * 1000;
    

    clearTimeout(s.init_page_timer);

    s.init_page_timer = setTimeout(function () {
      if (ics) animElements.init();
      // if (cont.is('.home')) pageHome.init();
      nextStep();
    }, trans_time/2);

    function nextStep() {
      s.init_page_timer = setTimeout(function () {
        initPageEnd();
      }, trans_time/2);
    }

    function initPageEnd() {
      pageloader.remove();

      if (cont.find('.video-wrap').length) ttVideo.init();
      if (cont.find('.tt-filter').length) ttFilterNav.init();
      if (cont.find('.pop').length) pop.init();
      if (cont.find('.cd-handle').length) ttComparison.init();
      
      ttLineNav.init();

      if ($('.ajax_pjc').length && !body_el.is('.single-projects')) ajaxLoad.alink('.ajax_pjc', true, 'project');
      if ($('.ajax_brand').length && !body_el.is('.single-brands')) ajaxLoad.alink('.ajax_brand', true, 'brand');

      if ($('.ajax_list_wrap').length && $('.loadmore-nav'.length)) ajaxLoadMore.init();

      // if (isDesktop) mouseScroll.init();

      // browserUpdate.init();
      cont.find('img:not(.qrcode-img):not(.candownload)').attr('oncontextmenu', 'return false').attr('ondragstart', 'return false');
    }
  }
}

jQuery(document).ready(function ($) {
  if (!body_el.is('.ff-form-preview-body')) {
    headerNav.init();
    // scrollSpy.init();
    ttAutoMoreNav.init();
    ajaxLoad.init();
    // darkMode.init();
    
    preloader.init();
    
    var scrollbar_w = scrollbarWidth();
    // console.log(scrollbar_w);
    if ( isDesktop && scrollbar_w > 0 ) document.documentElement.style.setProperty('--scrollbarW', scrollbar_w + 'px');
    if ( !$('html').is('.phone') && $('#midnight_nav').length && $(['data-midnight'].length) ) $('#midnight_nav').midnight();
  }

  // ttFluentform.init();
})
